import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BACKEND_URL } from '../app.config';
import { CreateUpdateDocRequestDto, DocRequest, ProcessTemplateSimple } from '../api/data-model';

@Injectable()
export class DocRequestService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BACKEND_URL) private readonly baseUrl: string
  ) {}

  getList(): Observable<DocRequest[]> {
    return this.http.get<DocRequest[]>(`${this.baseUrl}/api/app/doc-request`);
  }

  getProcessTemplates(id: string): Observable<ProcessTemplateSimple[]> {
    return this.http.get<ProcessTemplateSimple[]>(
      `${this.baseUrl}/api/app/doc-request/${id}/process-templates`
    );
  }

  create(input: CreateUpdateDocRequestDto): Observable<DocRequest> {
    return this.http.post<DocRequest>(`${this.baseUrl}/api/app/doc-request`, input);
  }

  update(id: string, input: CreateUpdateDocRequestDto): Observable<DocRequest> {
    return this.http.put<DocRequest>(`${this.baseUrl}/api/app/doc-request/${id}`, input);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/api/app/doc-request/${id}`);
  }
}
